module.exports = __webpack_public_path__ + "assets/checkmark-blue-c688a4.svg";